import styled from '@emotion/styled'
import Left from '@mui/icons-material/KeyboardArrowLeft'
import Right from '@mui/icons-material/KeyboardArrowRight'
import Fab from '@mui/material/Fab'
import { func, string, number } from 'prop-types'

const Button = styled(Fab)`
  position: absolute;
  margin-top: ${({ fromtop }) => fromtop}px;
  z-index: 4;
  ${({ direction }) => (direction === 'next' ? 'right' : 'left')}: 0;
`

const icons = {
  prev: Left,
  next: Right,
}

export const SlideButton = ({ onClick = () => {}, type = 'next', size = 211 }) => {
  const Icon = icons[type]
  return (
    <Button fromtop={(size - 56) / 2} direction={type} color="primary" onClick={onClick}>
      <Icon />
    </Button>
  )
}

SlideButton.propTypes = {
  onClick: func,
  type: string,
  size: number,
}
